import { Flask, Dna, Heartbeat, Watch, Sparkle } from "@phosphor-icons/react";
import { SectionTitle, FadeUp, HRule } from "./_shared";
import MatrixInputsPanel from "./_partials/MatrixInputsPanel";
import MatrixOutputPanel from "./_partials/MatrixOutputPanel";

const HERO_IMG =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/cg9jv6na_An_integrated_technology_ecosystem_wearable_data_from_apple_.png";

const INPUTS = [
  {
    icon: Flask,
    title: "Lab Work",
    body: "Full panels, advanced biomarkers, hormone & inflammation profiles.",
  },
  {
    icon: Dna,
    title: "DNA Analysis",
    body: "Genetic predispositions, pharmacogenomics, methylation patterns.",
  },
  {
    icon: Sparkle,
    title: "Microbiome",
    body: "Gut composition, diversity, metabolic & immune signatures.",
  },
  {
    icon: Heartbeat,
    title: "Biometrics",
    body: "Body composition, cardiometabolic markers, longitudinal vitals.",
  },
  {
    icon: Watch,
    title: "Wearables",
    body: "HRV, sleep, recovery, glucose, training & stress trends — continuously.",
  },
];

export default function MatrixEngine({ compactTop = false }) {
  return (
    <section
      id="matrix-engine"
      data-testid="matrix-engine-section"
      className={`${compactTop ? "pt-10 md:pt-12 pb-24 md:pb-36" : "py-24 md:py-36"} bg-background`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <FadeUp className="text-center">
          <div
            data-testid="matrix-engine-patent-eyebrow"
            className="font-display font-semibold tracking-tight text-accent
                       text-[clamp(1.25rem,3vw,2.25rem)] leading-tight"
          >
            Patent Pending Technology
          </div>
          <SectionTitle className="mt-6">
            Introducing the <em className="not-italic text-primary">Integrated Matrix Engine</em>
          </SectionTitle>
          <p className="mt-7 max-w-3xl mx-auto text-lg md:text-xl text-foreground/80 leading-relaxed text-pretty">
            Labs, DNA, microbiome, biometrics and wearables — fused into one clinical signal.
          </p>
        </FadeUp>

        <FadeUp delay={0.15} className="mt-12">
          <div className="relative aspect-[21/9] rounded-2xl overflow-hidden border border-border shadow-md bg-foreground">
            <img
              src={HERO_IMG}
              alt="Connected wearable, laboratory and biometric data flowing into one integrated health platform"
              data-testid="matrix-engine-hero-image"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground/25 via-transparent to-transparent" />
          </div>
        </FadeUp>

        <HRule />

        {/* Inputs → Engine → Outputs flow */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
          <FadeUp className="lg:col-span-7">
            <MatrixInputsPanel inputs={INPUTS} />
          </FadeUp>
          <FadeUp delay={0.1} className="lg:col-span-5">
            <MatrixOutputPanel />
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
